import React, { useCallback, useEffect, useRef, useState } from "react";
import ProfileNav from "../../components/ProfileNav";
import { fetchAudit } from "../../services/transactionService";
import toast from "react-hot-toast";
import Pagination from "../../components/Pagination";

const Audits = () => {
  const [audit, setAudit] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateInput, setStartDateInput] = useState("");
  const [endDateInput, setEndDateInput] = useState("");
  const [userName, setUsername] = useState(null);
  const [localUsername, setLocalUsername] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const itemsPerPage = 100;

  const getAuditLogs = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchAudit({
        startDate,
        endDate,
        userName,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
      });
      setAudit(res.data?.result);
      setTotalCount(res.data?.totalRecords);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    }
  }, [currentPage, startDate, endDate, userName]);

  useEffect(() => {
    getAuditLogs();
  }, [getAuditLogs]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const updateUsername = useRef(
    debounce((value) => {
      setUsername(value || null);
    }, 1000),
    []
  );

  const handleUsernameChange = (e) => {
    const value = e.target.value.trim();
    setLocalUsername(e.target.value);
    updateUsername.current(value || null);
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setStartDateInput(value); // update input

    if (!value) {
      setStartDate(null);
    } else {
      setStartDate(new Date(value + "T00:00:00Z").toISOString());
    }
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    setEndDateInput(value);

    if (!value) {
      setEndDate(null);
    } else {
      setEndDate(new Date(value + "T23:59:59Z").toISOString());
    }
  };

  const reset = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchAudit({
        startDate: null,
        endDate: null,
        userName: null,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
      });
      setAudit(res.data?.result);
      setTotalCount(res.data?.totalRecords);
      setStartDate(null);
      setEndDate(null);
      setStartDateInput("");
      setEndDateInput("");
      setLocalUsername("");
      setUsername(null);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    }
  }, [currentPage]);

  return (
    <div className="h-screen">
      <article className="h-screen flex gap-4">
        <section className="w-[48%] flex-grow-[6] pt-4 ">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-2xl font-bold text-navy-blue">
              Reports - Audits
            </h1>
            <div className="flex items-center gap-4">
              {/* <button className="bg-text-orange text-sm font-semibold w-[130px] h-[40px] rounded-md text-white">
                {" "}
                + New User
              </button> */}
              <div>
                <ProfileNav />
              </div>
            </div>
          </div>

          <div className="bg-white w-full">
            <div className="flex items-center justify-end gap-3 px-2">
              {/* <p className="border-r pr-5 font-normal text-[12px]">
                1 Selected
              </p> */}
              <span>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3367_2872)">
                    <path
                      d="M20.3333 14.3333V18.5C20.3333 18.9583 19.9583 19.3333 19.5 19.3333H9.5C9.04167 19.3333 8.66667 18.9583 8.66667 18.5V14.3333C8.66667 13.875 8.29167 13.5 7.83333 13.5C7.375 13.5 7 13.875 7 14.3333V19.3333C7 20.25 7.75 21 8.66667 21H20.3333C21.25 21 22 20.25 22 19.3333V14.3333C22 13.875 21.625 13.5 21.1667 13.5C20.7083 13.5 20.3333 13.875 20.3333 14.3333ZM15.3333 14.0583L16.9 12.4917C17.225 12.1667 17.75 12.1667 18.075 12.4917C18.4 12.8167 18.4 13.3417 18.075 13.6667L15.0833 16.6583C14.7583 16.9833 14.2333 16.9833 13.9083 16.6583L10.9167 13.6667C10.5917 13.3417 10.5917 12.8167 10.9167 12.4917C11.2417 12.1667 11.7667 12.1667 12.0917 12.4917L13.6667 14.0583V6.83333C13.6667 6.375 14.0417 6 14.5 6C14.9583 6 15.3333 6.375 15.3333 6.83333V14.0583Z"
                      fill="#323232"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3367_2872">
                      <rect width="28" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 8.75C5.69036 8.75 6.25 9.30964 6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25C15.6904 11.25 16.25 10.6904 16.25 10Z"
                    fill="#1C1C1C"
                  />
                </svg>
              </span>
            </div>
            <div className="flex items-center justify-between px-3 gap-2">
              <div className="flex items-center gap-2">
                <p className="border-r pr-5 text-sm font-semibold">
                  Audits History
                </p>
                <button
                  type="button"
                  onClick={reset}
                  className="h-10 px-3 rounded-md bg-white border text-sm font-medium text-gray-800 hover:bg-gray-50 transition"
                  aria-label="Reset filters"
                >
                  Reset
                </button>
                {/* <div className="flex items-center gap-2">
                  <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                  <p>Active</p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                  <p>Inactive</p>
                </div> */}
              </div>

              <div>
                <Pagination
                  totalItems={totalCount}
                  itemsPerPage={itemsPerPage}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              </div>
            </div>

            <table className="table-auto w-full border-collapse">
              <thead>
                <tr className="border-b bg-gray-50 text-xs text-gray-500">
                  <th className="px-4 py-2 text-left font-medium">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" className="accent-gray-700" />
                      <span>ID</span>
                    </label>
                  </th>
                  <th className="px-4 py-2 text-left font-medium">Path</th>
                  <th className="px-4 py-2 text-left font-medium">UserName</th>
                  <th className="px-4 py-2 text-left font-medium">TimeStamp</th>
                  <th className="px-4 py-2 text-left font-medium">Method</th>
                  <th className="px-4 py-2 text-left font-medium">Message</th>
                  <th className="px-4 py-2 text-left font-medium">Payload</th>
                  <th className="px-4 py-2 text-left font-medium">
                    Merchant ID
                  </th>
                </tr>
                <tr className="border-b bg-white text-gray-700">
                  <th></th>
                  <th></th>
                  <th className="px-3 py-2">
                    <input
                      type="text"
                      placeholder="Search Username"
                      onChange={handleUsernameChange}
                      value={localUsername}
                      className="w-full border border-gray-300 rounded-md px-2 py-1 text-xs focus:ring-2 focus:ring-orange-300 focus:outline-none"
                    />
                  </th>
                  <th className="px-3 py-2 flex flex-col gap-1">
                    <input
                      type="date"
                      placeholder="Start Date"
                      onChange={handleStartDateChange}
                      value={startDateInput}
                      className="w-full border border-gray-300 rounded-md px-2 py-1 text-xs focus:ring-2 focus:ring-orange-300 focus:outline-none"
                    />
                    <input
                      type="date"
                      placeholder="End Date"
                      onChange={handleEndDateChange}
                      value={endDateInput}
                      className="w-full border border-gray-300 rounded-md px-2 py-1 text-xs focus:ring-2 focus:ring-orange-300 focus:outline-none"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-6 text-gray-500">
                      Audit Logs Loading...
                    </td>
                  </tr>
                ) : (
                  audit.map((item) => (
                    <tr
                      key={item.id}
                      className="border-b hover:bg-gray-50 text-sm text-gray-700"
                    >
                      <td className="px-4 py-3 whitespace-nowrap">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" className="accent-gray-700" />
                          <span>{item.id}</span>
                        </label>
                      </td>
                      <td className="px-4 py-3 max-w-[200px] truncate">
                        {item.path}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {item.userName}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {new Date(item.timestamp).toLocaleString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {item.method}
                      </td>
                      <td className="px-4 py-3 max-w-[200px] truncate">
                        {item.message}
                      </td>
                      <td className="px-4 py-3 max-w-[200px] align-top">
                        {(() => {
                          try {
                            const parsed = JSON.parse(item.payload);
                            return (
                              <pre className="bg-gray-50 p-2 rounded text-xs text-gray-700 overflow-x-auto">
                                {JSON.stringify(parsed, null, 2)}
                              </pre>
                            );
                          } catch {
                            // fallback in case it's not valid JSON
                            return (
                              <span className="text-xs text-gray-700">
                                {item.payload}
                              </span>
                            );
                          }
                        })()}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {item.merchantId}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>
      </article>
      <style>
        {`
        /* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 12px;
  color: rgba(28, 28, 28, 0.4);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 13.5px;
  width: 13.5px;
  background-color: #eee;
  border-radius: 3px;
  margin-top:2px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #323232;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
        `}
      </style>
    </div>
  );
};

export default Audits;
